import { FormSection } from "components/MainSectionTemplate/types";
import React from "react";
import { DaysAfterDateInput, DaysAfterDateText } from "./DaysAfterDateRow";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";

interface Props {
  instruction: server.dto.UpdateClientConfigurationInstruction
}

const reminders = [1, 2, 3];

const hasESignActivated = (instruction: server.dto.UpdateClientConfigurationInstruction) =>
  instruction.eSignEnabled === "legacyAndESign" || instruction.eSignEnabled === "onlyESign";

const hasOnlyLegacy = (instruction: server.dto.UpdateClientConfigurationInstruction) =>
  instruction.eSignEnabled === "onlyLegacy";

export const ESignSection = (props: Props): FormSection => {
  return {
    key: "esignSettings",
    type: "regular",
    title: RESX.ESign.eSign,
    fields: [{
      key: "esign_enabled",
      label: RESX.EmbedWizard.Display,
      render: () => <div>{esignOptions.find(option => option.value === props.instruction.eSignEnabled).label}</div>,
      hidden: !hasOnlyLegacy(props.instruction) && !site.isImpersonated,
      inPageEdit: {
        render: ({ onChange, value }) => <div className="main-section-template-fields-padding">
          <RadioGroup
            orientation="horizontal"
            options={esignOptions}
            value={value}
            onChange={v => onChange(v, true)}
          />
        </div>,
        type: "custom",
        initialValue: props.instruction.eSignEnabled,
        submitChange: (value: server.dto.ESignEnabled) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, eSignEnabled: value });
        }
      }
    },
    ...reminders.map((_, i) => ({
      key: `esign_reminder_${i + 1}`,
      label: `${RESX.Reminder.xReminder} ${i + 1}`,
      render: () => <DaysAfterDateText days={props.instruction.eSignReminderInterval[i]} type="send" />,
      hidden: !hasESignActivated(props.instruction),
      inPageEdit: {
        render: ({ onChange, value, cancel }) => <DaysAfterDateInput
          value={value}
          onChange={onChange}
          maxValue={serverReference.constants.eSign.maxReminderInterval}
          type="send"
          onEnter={v => onChange(v, true)}
          onEsc={cancel}
        />,
        type: "confirmOrCancelButton" as const,
        initialValue: props.instruction.eSignReminderInterval[i],
        submitChange: (value: number) => {
          const newIntervals = [...props.instruction.eSignReminderInterval];
          newIntervals[i] = value;
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, eSignReminderInterval: newIntervals });
        }
      }
    }))
    ]
  }
}

interface ESignOption {
  value: server.dto.ESignEnabled
  label: string
};

const esignOptions: ESignOption[] = [{
  value: "onlyLegacy",
  label: "Only classic workflow (no eSign)"
}, {
  value: "legacyAndESign",
  label: "Classic workflow and eSign"
}, {
  value: "onlyESign",
  label: "Only eSign"
}];